import { useMemo } from 'react'

import { Footer } from './components/Footer'
import { TimeWindows } from './components/TimeWindows'
import { form } from './formState'

import { useFormInitialValues } from './hooks/useFormInitialValues'
import { useOnSubmit } from './hooks/useOnSubmit'
import { useValidateForm } from './hooks/useValidateForm'

export function EditTimeWindows() {
  const initialValues = useFormInitialValues()
  const validateForm = useValidateForm()
  const onSubmit = useOnSubmit()

  const config = useMemo(
    () => ({
      id: 'traffic-profile-time-windows-form',
      initialValues,
    }),
    [initialValues],
  )

  return (
    <form.Form
      width={320}
      header={null}
      config={config}
      footer={<Footer />}
      onSubmit={onSubmit}
      sx={{ padding: 0 }}
      onValidate={validateForm}
      requireTransaction
      stopEditingOnUnmount={false}
      applyPendingFitMapOnMount={false}
    >
      <TimeWindows />
    </form.Form>
  )
}
